import { useEffect, useRef, useState } from 'react';

export default function useContainerWidth() {
    const ref = useRef(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;

        setWidth(el.getBoundingClientRect().width);

        let frameId = null;
        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (!entry) return;
            cancelAnimationFrame(frameId);
            frameId = requestAnimationFrame(() => setWidth(entry.contentRect.width));
        });
        observer.observe(el);

        return () => {
            cancelAnimationFrame(frameId);
            observer.disconnect();
        };
    }, []);

    return [ref, width];
}
